<script lang="ts">
    import { t } from "@lernetz/svelte-translate";
    import { router } from "@inertiajs/svelte";
    import { Icon } from "@lernetz/svelte-icon";
    import { setupSharedProps, sharedProps } from "../../setup";

    export let onClose: () => void;
    export let dashboard;
    export let type;
    export let preview;

    setupSharedProps();

    let pupils: number;
    const MAX_PUPILS = 50;

    $: isValid = pupils > 0 && pupils <= MAX_PUPILS;

    function goToExam() {
        let code;
        if(type == "prior") {
            code = dashboard.priorCode
        }
        else {
            code = dashboard.afterCode
        }
        router.get("/class/"+type+"/"+code, {
            pupils: pupils,
            preview: preview,
        });
    }

</script>
<div class="w-full h-full fixed inset-0 {dashboard.cycle == 'cycle1' ? 'bg-yellow-light' : 'bg-green-light'} flex flex-col items-center z-30 p-16 md:p-24 overflow-y-auto">
<div class="flex justify-between w-full max-w-1280 items-start gap-12">
    <button on:click="{onClose}" class="w-48 h-48 bg-blue-main text-white rounded-md z-10 shrink-0">
        <Icon name="close" class="w-28 h-28 place-self-center"></Icon>
    </button>
    <Icon name="{sharedProps.currentLocale == 'de' ? 'logo-element-hero' : 'logo-element-hero-fr'}" class="w-96 md:w-128 xl:w-160 shrink-0 -mt-24 md:-mt-48"></Icon>
</div>
    <div class="w-full flex justify-center items-center mt-24 md:mt-40 text-center">
        <div class="text-28 md:text-36 font-bold">
            {$t('Number of pupils')}
        </div>
    </div>
    <div class="mt-32 md:mt-80 text-18 text-center px-16">
        {$t('How many pupils take part in the knowledge test?')}
    </div>
    <div class="mt-24 md:mt-32 w-full max-w-256">
        <input id="name" type="number" min="1" max={MAX_PUPILS} placeholder="16" bind:value={pupils} class="mt-10 border-blue-light border-2 rounded-lg text-18 px-16 py-8 w-full appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]"/>
        <div class="text-14 mt-8 text-center {pupils > MAX_PUPILS ? 'text-false-dark font-bold' : 'text-grey-1'}">{$t('Maximum')} {MAX_PUPILS}</div>
    </div>
    <button class="mt-32 md:mt-64 px-16 py-10 text-white rounded-md {!isValid ? 'bg-blue-light' : 'bg-blue-main'}" on:click={goToExam} disabled={!isValid}>
        {$t("let's go")}
    </button>
</div>
